import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import { InboxOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { Button, Divider, Form, Input, Select, Typography } from 'antd';
import { message, Upload } from 'antd';
import { useState } from 'react';
import { Editor, EditorState } from 'react-draft-wysiwyg';

import { Role } from '@/types';

const { Title } = Typography;
const { Dragger } = Upload;

const props: UploadProps = {
  name: 'file',
  multiple: true,
  action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  onChange(info) {
    const { status } = info.file;
    if (status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
  onDrop(e) {
    console.log('Dropped files', e.dataTransfer.files);
  }
};

function AddIssue() {
  const [editorState, setEditorState] = useState<EditorState>();
  return (
    <>
      <Title>Add Issue</Title>
      <Divider />
      <Form
        name="basic"
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        initialValues={{ remember: true }}
        onFinish={(v) => console.log(v)}
        autoComplete="off"
      >
        <Form.Item label="Main Image" name="main-image" rules={[{ required: true }]}>
          <Dragger {...props}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
            <p className="ant-upload-hint">
              Support for a single or bulk upload. Strictly prohibited from uploading company data or other banned
              files.
            </p>
          </Dragger>
        </Form.Item>
        <Form.Item label="Title" name="title" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item label="Vote Description" name="vote-description" rules={[{ required: true }]}>
          <Input.TextArea />
        </Form.Item>
        <Form.Item label="Vote Rule" name="vote-rule" rules={[{ required: true }]}>
          <Select defaultValue="simple-majority" options={[{ value: 'simple-majority', label: 'simple majority' }]} />
        </Form.Item>
        <Form.Item label="Vote Permission" name="vote-permission" rules={[{ required: true }]}>
          <Select
            mode="multiple"
            defaultValue={[Role.ADMIN, Role.CONTRIBUTOR]}
            options={[
              { value: Role.ADMIN, label: Role.ADMIN },
              { value: Role.DEVELOPER, label: Role.DEVELOPER },
              { value: Role.CONTRIBUTOR, label: Role.CONTRIBUTOR }
            ]}
          />
        </Form.Item>

        <Form.Item label="Content" name="content" rules={[{ required: true }]}>
          <div style={{ background: 'white', height: '400px' }}>
            <Editor
              editorState={editorState}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="editorClassName"
              onEditorStateChange={setEditorState}
            />
          </div>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 4, span: 20 }}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}

export default AddIssue;
